import { MenuItem, Stack, TextField } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import type { TextBlockContent } from '@/types/database';

// These options are literally MUI Typography's own `variant`/`align` props.
const VARIANT_OPTIONS: TextBlockContent['variant'][] = ['body1', 'body2', 'h4', 'h5', 'h6'];
const ALIGN_OPTIONS: TextBlockContent['align'][] = ['left', 'center', 'right'];

export function TextBlockEditPanel({
  content,
  onUpdate,
}: {
  content: TextBlockContent;
  onUpdate: (content: TextBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content || { content: '' }, onUpdate);

  return (
    <Stack spacing={1.5}>
      <TextField
        label="Content"
        value={draft.content || ''}
        onChange={(event) => update({ ...draft, content: event.target.value })}
        multiline
        minRows={4}
        fullWidth
      />
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <TextField
          select
          label="Variant"
          value={draft.variant ?? 'body1'}
          onChange={(event) => update({ ...draft, variant: event.target.value as TextBlockContent['variant'] }, { immediate: true })}
          fullWidth
        >
          {VARIANT_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
        <TextField
          select
          label="Align"
          value={draft.align ?? 'left'}
          onChange={(event) => update({ ...draft, align: event.target.value as TextBlockContent['align'] }, { immediate: true })}
          fullWidth
        >
          {ALIGN_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </TextField>
      </Stack>
    </Stack>
  );
}
